<template>
    <div>
        <PageTitle title="Política de privacidad"></PageTitle>
        <FirstBanner></FirstBanner>
        <section class="padding-vertical-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <p v-html="manager.privacidad"></p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';

    export default {
        data() {
            return {
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        components: {
            PageTitle, FirstBanner
        }
    }
</script>
